<template>
    <div class="modal-overlay breakupmodal">
        <div class="modal-dialog-breakup pt-4" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">
                        <h2 class="premium-revised-title">
                            Based on Proposal Details, Your premium has been revised
                        </h2>
                    </h5>
                </div>
                <div class="modal-body">
                    <div class="premium-comparison">
                        <table class="differernce_table">
                            <thead>
                                <tr>
                                    <th class="table-header-cell"></th>
                                    <td class="table-header-cell"><span>BEFORE</span></td>
                                    <td class="table-header-cell"><span>AFTER</span></td>
                                </tr>
                            </thead>
                            <tbody>
                                <tr class="">
                                    <th> Final Premium (GST inc.)</th>
                                    <td>
                                        <span class="premium-amount">&#8377; {{
                                            premiumRound(selectedPlan.productDetails?.totalPremiumDetails[0]?.totalPremiumWithTax)
                                            }}</span>
                                    </td>
                                    <td>
                                        <span class="premium-amount premium-amount-after">&#8377; {{
                                            premiumRound(updatedPlanData.productDetails.totalPremiumDetails[0].totalPremiumWithTax)
                                            }}</span>
                                    </td>
                                </tr>
                                <tr v-if="!['StandaloneTP(1)', 'StandaloneTP(3)', 'StandaloneTP(5)'].includes(selectedPlan?.insuranceAndProducts?.policyType)">
                                    <th>IDV Cover</th>
                                    <td>
                                        <span>&#8377; {{
                                            premiumRound(selectedPlan.supportingData.insuredDeclaredValue.suggestedIDV)
                                        }}</span>
                                    </td>
                                    <td>
                                        <span>&#8377; {{
                                            premiumRound(updatedPlanData.supportingData.insuredDeclaredValue.suggestedIDV)
                                        }}</span>
                                    </td>
                                </tr>
                                <tr class="section-header">
                                    <th colspan="3">Base Cover</th>
                                </tr>
                                <tr v-if="isNotZeroOwnDamage">
                                    <th>Basic Own Damage Premium</th>
                                    <td>
                                        <span>₹ {{
                                            currency(selectedPlan.productDetails.basicOwnDamagePremiumForEachPolicyTerm.premiumForEachPolicyTerm[0].premiumForEachPPO[0].premiumForEachPPF[0].basicODPremiumValue)
                                            }}
                                        </span>
                                    </td>
                                    <td>
                                        <span>₹ {{
                                            currency(updatedPlanData.productDetails.basicOwnDamagePremiumForEachPolicyTerm.premiumForEachPolicyTerm[0].premiumForEachPPO[0].premiumForEachPPF[0].basicODPremiumValue)
                                            }}
                                        </span>
                                    </td>
                                </tr>
                                <tr v-if="isNotZeroThirdParty">
                                    <th>Basic Third Party Premium</th>
                                    <td>
                                        <span>₹ {{
                                            currency(selectedPlan?.productDetails?.thirdPartyPremiumForEachPolicyTerm.premiumForEachPolicyTerm[0].premiumForEachPPO[0].premiumForEachPPF[0].basicTPPremiumValue)
                                            }}
                                        </span>
                                    </td>
                                    <td>
                                        <span>₹ {{
                                            currency(updatedPlanData.productDetails?.thirdPartyPremiumForEachPolicyTerm.premiumForEachPolicyTerm[0].premiumForEachPPO[0].premiumForEachPPF[0].basicTPPremiumValue)
                                            }}
                                        </span>
                                    </td>
                                </tr>
                                <tr v-for="addons in getFilteredBasicAddon" :key="addons.optionSelected">
                                    <th>{{ addons.optionDescription }} 
                                        <span v-if="addons.optionSelected == 'paCvr'" class="si_value">(SI ₹ 15,00,000)</span>
                                        <span v-else-if="addons.optionValue.length == 1 && (addons.optionValue[0].optionValueInput != 0 && addons.optionValue[0].optionValueInput != 1) && addons.optionSelected != 'tpCngCvr'" class="si_value">
                                            (SI ₹ {{ currency(addons.optionValue[0].optionValueInput) }})
                                        </span>
                                    </th>
                                    <td v-if="showPrimium(addons.premiumForEachPolicyTerm[0].premiumForEachPPO[0].premiumForEachPPF[0].premiumValue, addons.premiumIncludedFlag) === 'Included' && getFromUpdateSelectedPlan(addons.optionSelected) === 'Included'">
                                        <span class="included-text">Included</span>
                                    </td>
                                    <td v-if="showPrimium(addons.premiumForEachPolicyTerm[0].premiumForEachPPO[0].premiumForEachPPF[0].premiumValue, addons.premiumIncludedFlag) === 'Included' && getFromUpdateSelectedPlan(addons.optionSelected) === 'Included'">
                                        <span class="included-text">Included</span>
                                    </td>
                                    <template v-else>
                                        <td>
                                            <span>₹ {{
                                                showPrimium(addons.premiumForEachPolicyTerm[0].premiumForEachPPO[0].premiumForEachPPF[0].premiumValue,
                                                    addons.premiumIncludedFlag)
                                            }}
                                            </span>
                                        </td>
                                        <td>
                                            <span> ₹ {{ getFromUpdateSelectedPlan(addons.optionSelected) }} </span>
                                        </td>
                                    </template>
                                </tr>
                                <tr v-if="getFilterAddons.length > 0" class="section-header">
                                    <th colspan="3">Addons</th>
                                </tr>
                                <tr v-for="addons in getFilterAddons" :key="addons.optionSelected">
                                    <th>{{ addons.optionDescription }}</th>
                                    <td v-if="showPrimium(addons.premiumForEachPolicyTerm[0].premiumForEachPPO[0].premiumForEachPPF[0].premiumValue, addons.premiumIncludedFlag) === 'Included' && getFromUpdateSelectedPlan(addons.optionSelected) === 'Included'">
                                        <span class="included-text">Included</span>
                                    </td>
                                    <td v-if="showPrimium(addons.premiumForEachPolicyTerm[0].premiumForEachPPO[0].premiumForEachPPF[0].premiumValue, addons.premiumIncludedFlag) === 'Included' && getFromUpdateSelectedPlan(addons.optionSelected) === 'Included'">
                                        <span class="included-text">Included</span>
                                    </td>
                                    <template v-else>
                                        <td>
                                            <span>₹ {{
                                                showPrimium(addons.premiumForEachPolicyTerm[0].premiumForEachPPO[0].premiumForEachPPF[0].premiumValue,
                                                    addons.premiumIncludedFlag)
                                            }}
                                            </span>
                                        </td>
                                        <td>
                                            <span> ₹ {{
                                                getFromUpdateSelectedPlan(addons.optionSelected)
                                                }}
                                            </span>
                                        </td>
                                    </template>
                                </tr>
                                <tr v-if="getFilterAccessories.length > 0" class="section-header">
                                    <th colspan="3">Accessories</th>
                                </tr>
                                <tr v-for="addons in getFilterAccessories" :key="addons.optionSelected">
                                    <th>{{ addons.optionDescription }}
                                        <span class="si_value" v-if="!(fuelType == 'cng' || fuelType == 'lpg')">(SI ₹ {{ currency(addons.optionValue[0].optionValueInput) }})</span>
                                    </th>
                                    <td v-if="showPrimium(addons.premiumForEachPolicyTerm[0].premiumForEachPPO[0].premiumForEachPPF[0].premiumValue, addons.premiumIncludedFlag) === 'Included' && getFromUpdateSelectedPlan(addons.optionSelected) === 'Included'">
                                        <span class="included-text">Included</span>
                                    </td>
                                    <td v-if="showPrimium(addons.premiumForEachPolicyTerm[0].premiumForEachPPO[0].premiumForEachPPF[0].premiumValue, addons.premiumIncludedFlag) === 'Included' && getFromUpdateSelectedPlan(addons.optionSelected) === 'Included'">
                                        <span class="included-text">Included</span>
                                    </td>
                                    <template v-else>
                                        <td>
                                            <span>₹ {{
                                                showPrimium(addons.premiumForEachPolicyTerm[0].premiumForEachPPO[0].premiumForEachPPF[0].premiumValue,
                                                    addons.premiumIncludedFlag)
                                            }}
                                            </span>
                                        </td>
                                        <td>
                                            <span> ₹ {{
                                                getFromUpdateSelectedPlan(addons.optionSelected)
                                                }}
                                            </span>
                                        </td>
                                    </template>
                                </tr>
                                <tr v-if="selectedPlan?.productDetails?.motorNCBPremium[0].premiumForEachPolicyTerm[0].premiumForEachPPO[0].premiumForEachPPF[0].premiumValue || getDiscountListData.length > 0" class="section-header">
                                    <th colspan="3">Discounts</th>
                                </tr>
                                <tr v-if="selectedPlan?.productDetails?.motorNCBPremium[0].premiumForEachPolicyTerm[0].premiumForEachPPO[0].premiumForEachPPF[0].premiumValue">
                                    <th>No-Claim Bonus</th>
                                    <td>
                                        <span class="discount-amount">₹
                                            {{
                                                currency(selectedPlan?.productDetails?.motorNCBPremium[0]?.premiumForEachPolicyTerm[0]?.premiumForEachPPO[0]?.premiumForEachPPF[0]?.premiumValue)
                                            }}</span>
                                    </td>
                                    <td>
                                        <span class="discount-amount">₹
                                            {{
                                                currency(updatedPlanData?.productDetails?.motorNCBPremium[0]?.premiumForEachPolicyTerm[0]?.premiumForEachPPO[0]?.premiumForEachPPF[0]?.premiumValue)
                                            }}</span>
                                    </td>
                                </tr>
                                <tr v-for="addons in getDiscountListData" :key="addons.optionSelected">
                                    <th>{{ addons.optionDescription }}
                                        <span v-if="addons.optionValue.length == 1 && addons.optionValue[0].optionValueInput != 0 && !(addons.optionSelected == 'payAsDrv' || addons.optionSelected == 'autoasso')" class="si_value">
                                                    (SI ₹ {{ formatIndianCurrency(addons.optionValue[0].optionValueInput) }})
                                                </span>
                                                <span v-else-if="addons.optionValue.length == 1 && addons.optionValue[0].optionValueInput != 0 && addons.optionSelected != 'autoasso'" class="si_value">
                                                    (SI {{ formatIndianCurrency(addons.optionValue[0].optionValueInput) }} km/yr)
                                                </span>
                                    </th>
                                    <td v-if="showPrimium(addons.premiumForEachPolicyTerm[0].premiumForEachPPO[0].premiumForEachPPF[0].premiumValue, addons.premiumIncludedFlag) === 'Included' && getFromUpdateSelectedPlan(addons.optionSelected) === 'Included'">
                                        <span class="included-text">Included</span>
                                    </td>
                                    <td v-if="showPrimium(addons.premiumForEachPolicyTerm[0].premiumForEachPPO[0].premiumForEachPPF[0].premiumValue, addons.premiumIncludedFlag) === 'Included' && getFromUpdateSelectedPlan(addons.optionSelected) === 'Included'">
                                        <span class="included-text">Included</span>
                                    </td>
                                    <template v-else>
                                        <td>
                                            <span class="discount-amount">- ₹ {{
                                                showPrimium(addons.premiumForEachPolicyTerm[0].premiumForEachPPO[0].premiumForEachPPF[0].premiumValue,
                                                    addons.premiumIncludedFlag)
                                            }}
                                            </span>
                                        </td>
                                        <td>
                                            <span class="discount-amount">- ₹ {{
                                                getFromUpdateSelectedPlan(addons.optionSelected)
                                                }}
                                            </span>
                                        </td>
                                    </template>
                                </tr>
                                <tr class="section-header">
                                    <th colspan="3">Premium Details</th>
                                </tr>
                                <tr>
                                    <th>Package Premium</th>
                                    <td>
                                        <span class="discount-amount">₹
                                            {{
                                                currency(selectedPlan?.productDetails?.totalPremiumDetails[0].totalPremiumValueBeforeTax)
                                            }}</span>
                                    </td>
                                    <td>
                                        <span class="discount-amount">₹
                                            {{
                                                currency(updatedPlanData?.productDetails?.totalPremiumDetails[0].totalPremiumValueBeforeTax)
                                            }}</span>
                                    </td>
                                </tr>
                                <tr>
                                    <th>GST@18%</th>
                                    <td>
                                        <span class="discount-amount">₹
                                            {{
                                                currency(selectedPlan?.productDetails?.totalPremiumDetails[0].totalTax)
                                            }}</span>
                                    </td>
                                    <td>
                                        <span class="discount-amount">₹
                                            {{
                                                currency(updatedPlanData?.productDetails?.totalPremiumDetails[0].totalTax)
                                            }}</span>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <div class="inspection-info">
                        <span class="inspection-text">
                            <img v-if="motorProductType == '4W-Pvt'" src="@/assets/images/inspection-icon.png"/> 
                            <img v-else src="@/assets/images/inspection-bike.png"/> 
                            <span>Inspection Required: </span>
                            <span :class="{'inspection-required': updatedPlanData.productDetails.inspectionDetails.isInspectionRequired === true}">
                                {{updatedPlanData.productDetails.inspectionDetails.isInspectionRequired === true ? "YES" : "NA"}}
                            </span>
                        </span>
                    </div>

                    <div class="modal-footer">
                        <button type="button" class="btn commonButton" @click="goToMQ()">
                            View Other Plans
                        </button>
                        <button type="button" class="btn commonButton primary-btn" @click="continueNewPremium()">
                            Continue with this Premium
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props: ["updatedPlanData", "selectedPlan"],
    data() {
        return {
            motorProductType: "",
            fuelType: ""
        };
    },
    mounted() {
        this.motorProductType = this.$store.state.motorProductType;
        let userData = JSON.parse(sessionStorage.getItem("userData"));
        this.fuelType = userData?.fuelType;
    },
    methods: {
        currency(amt) {
            if (amt) {
            const tmpAmt = parseFloat(amt).toFixed(2);
                return tmpAmt.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            } else {
                return "0.00";
            }
        },
        premiumRound(amount){
           return Math.round(amount);
        },
        emitClose() {
            this.$emit("emitVerifyClose");
        },
        continueNewPremium() {
            this.$emit("continueNewPremium");
        },
        goToMQ() {
            this.$router.push({ name: "MultipleQuotes" });
        },
        showPrimium(amount, premiumIncludedFlag) {
            if (premiumIncludedFlag === "Yes" || premiumIncludedFlag == 1) {
                return "Included"
            }
            else {
                return this.currency(amount)
            }
        },
        getFromUpdateSelectedPlan(optionSelected) {
            const data = this.getUpdatePlanFilteredAddons.filter((ele) => {
                return ele.optionSelected === optionSelected;
            })[0];
            return this.showPrimium(data?.premiumForEachPolicyTerm[0]?.premiumForEachPPO[0]?.premiumForEachPPF[0]?.premiumValue, data?.premiumIncludedFlag) || "0.00"
        }
    },
    computed: {
        getUpdatePlanFilteredAddons() {
            const filteredaddon = this.updatedPlanData.productDetails.motorCovers.filter(option => {
                const isAllConditionsMet = option.inbuiltInPlan === "No" &&
                    option.mandatoryInProduct === "No" &&
                    option.premiumForEachPolicyTerm.every(term =>
                        term.premiumForEachPPO.every(ppo =>
                            ppo.premiumForEachPPF.every(ppf =>
                                ppf.totalPremiumValue === 0 || ppf.totalPremiumValue === null
                            )
                        )
                    ) &&
                    option.premiumIncludedFlag === "No";
                return !isAllConditionsMet;
            });
            return filteredaddon;
        },
        getFilteredAddons() {
            const filteredaddon = this.selectedPlan.productDetails.motorCovers.filter(option => {
                const isAllConditionsMet = option.inbuiltInPlan === "No" &&
                    option.mandatoryInProduct === "No" &&
                    option.premiumForEachPolicyTerm.every(term =>
                        term.premiumForEachPPO.every(ppo =>
                            ppo.premiumForEachPPF.every(ppf =>
                                ppf.totalPremiumValue === 0 || ppf.totalPremiumValue === null
                            )
                        )
                    ) &&
                    option.premiumIncludedFlag === "No";
                return !isAllConditionsMet;
            });
            return filteredaddon;
        },
        getFilteredBasicAddon() {
            const filteredBasicAddon = this.getFilteredAddons
                .filter((addon) => this.getPremiumBreakup.basic_cover.includes(addon.optionSelected))
                .sort((a, b) => {
                    const aIndex = this.getPremiumBreakup.basic_cover.indexOf(a.optionSelected);
                    const bIndex = this.getPremiumBreakup.basic_cover.indexOf(b.optionSelected);
                    return aIndex - bIndex;
                });
            return filteredBasicAddon;
        },
        getFilterAddons() {
            const filteredAddonsbreakup = this.getFilteredAddons.filter((addon) =>
                this.getPremiumBreakup.Addons.includes(addon.optionSelected)).sort((a, b) => {
                    const aIndex = this.getPremiumBreakup.Addons.indexOf(a.optionSelected);
                    const bIndex = this.getPremiumBreakup.Addons.indexOf(b.optionSelected);
                    return aIndex - bIndex;
                });
            return filteredAddonsbreakup;
        },
        getFilterAccessories() {
            const filteredAccessories = this.getFilteredAddons.filter((addon) =>
                this.getPremiumBreakup.Accessories.includes(addon.optionSelected)).sort((a, b) => {
                    const aIndex = this.getPremiumBreakup.Accessories.indexOf(a.optionSelected);
                    const bIndex = this.getPremiumBreakup.Accessories.indexOf(b.optionSelected);
                    return aIndex - bIndex;
                });
            return filteredAccessories;
        },
        getDiscountListData() {
            const allDiscounts = this.getFilteredAddons.filter((addon) =>
                ["volDed", "autoasso", "antiThft", "payAsDrv"].includes(addon.optionSelected)
            );
            const applicableDiscount = [];
            allDiscounts.forEach(discount => {
                const matchingCover = this.selectedPlan.productDetails.motorCovers.find(
                    cover => cover.optionSelected === discount.optionSelected
                );
                if (matchingCover) {
                    discount.premiumIncludedFlag = matchingCover.premiumIncludedFlag;
                    applicableDiscount.push(discount);
                }
            });
            return applicableDiscount;
        },
        isNotZeroOwnDamage() {
            return this.currency(this.selectedPlan.productDetails.basicOwnDamagePremiumForEachPolicyTerm.premiumForEachPolicyTerm[0].premiumForEachPPO[0].premiumForEachPPF[0].basicODPremiumValue) !== "0.00" && "0.00" !== this.currency(this.updatedPlanData.productDetails.basicOwnDamagePremiumForEachPolicyTerm.premiumForEachPolicyTerm[0].premiumForEachPPO[0].premiumForEachPPF[0].basicODPremiumValue);
        },
        isNotZeroThirdParty() {
            return this.currency(this.selectedPlan?.productDetails?.thirdPartyPremiumForEachPolicyTerm.premiumForEachPolicyTerm[0].premiumForEachPPO[0].premiumForEachPPF[0].basicTPPremiumValue) !== "0.00" && "0.00" !== this.currency(this.updatedPlanData.productDetails?.thirdPartyPremiumForEachPolicyTerm.premiumForEachPolicyTerm[0].premiumForEachPPO[0].premiumForEachPPF[0].basicTPPremiumValue);
        },
        getPremiumBreakup() {
            return this.$store.state.configData && this.$store.state.configData.PREMIUM_BREAKUP ? this.$store.state.configData.PREMIUM_BREAKUP : {};
        }
    },
};
</script>
<style lang="scss">
@import "../assets/scss/components/modals.scss";

.modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: rgba(0, 0, 0, 0.5);
    backdrop-filter: blur(5px);
    z-index: 10;
}

.modal-dialog-breakup {
    position: relative;
    background-color: $commonColor;
    max-width: 740px !important;
    height: 85vh;
    overflow-y: auto;
    min-width: 400px;
    border-radius: 16px;
    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
    padding: 24px;

    &::-webkit-scrollbar {
        width: 8px;
    }
    
    &::-webkit-scrollbar-track {
        background: $cardBg;
        border-radius: 10px;
    }
    
    &::-webkit-scrollbar-thumb {
        background: $gray-400;
        border-radius: 10px;
    }
}

.modal-content {
    border: none;
    background-color: transparent;
}

.modal-header {
    border: none;
    padding: 0 0 16px 0;
    border-bottom: 1px solid $gray-300;
    margin-bottom: 20px;
    
    .premium-revised-title {
        color: $success !important;
        font-size: 18px;
        font-weight: 600;
        margin: 0;
        text-align: center;
        width: 100%;
    }
}

.modal-body {
    padding: 0;
}

.premium-comparison {
    margin-bottom: 24px;
}

.differernce_table {
    border-collapse: collapse;
    width: 100%;
    border-radius: 8px;
    overflow: hidden;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.05);

    thead {
        background-color: $main-bg;
        
        th, td {
            border: none !important;
            background-color: transparent !important;
            color: $commonColor;
            font-weight: 600;
            padding: 12px 16px;
            font-size: 14px;
        }
        
        .table-header-cell {
            text-align: start;
        }
    }

    tbody {
        tr {
            &:nth-child(even) {
                // background-color: $cardBg;
            }
            
            &:hover {
                background-color: $gray-200;
            }
        }
        
        tr.highlight-row {
            background-color: rgba($main-bg, 0.1);
            
            td {
                font-weight: 600;
            }
        }
        
        tr.section-header {
            background-color: $gray-200;
            // background-color: $main-bg;
            
            th {
                text-align: left;
                padding: 10px 16px;
                font-size: 15px;
                color: $text-color;
                // color: $commonColor;
                font-weight: 600;
            }
        }

        th, td {
            border: none;
            padding: 10px 16px;
            text-align: left;
            vertical-align: middle;
            font-size: 14px;
        }

        th {
            font-weight: 500;
            color: $text-color;
        }
        
        td {
            color: $base-text;
            
            .premium-amount {
                font-weight: 600;
                color: $text-color;
            }
            
            .premium-amount-after {
                color: $active;
            }
            
            .discount-amount {
                color: $success;
                font-weight: 500;
            }
            
            .included-text {
                color: $verify-color;
                font-weight: 500;
            }
        }
    }
}

.inspection-info {
    background-color: $cardBg;
    padding: 16px;
    border-radius: 8px;
    margin: 20px 0;
    
    .inspection-text {
        font-size: 16px;
        font-weight: 500;
        img{
            width: 32px;
            height: auto;
        }
        span{
            color: #EC920F !important;
        }
    }
    
    .inspection-required {
        color: $error-txt;
        font-weight: 600;
    }
}

.modal-footer {
    display: flex !important;
    justify-content: space-between !important;
    align-items: center !important;
    border-top: none;
    padding: 20px 0 0 0;
    margin-top: 20px;
    
    button {
        width: 48%;
        border-radius: 8px;
        padding: 12px;
        font-weight: 500;
        font-size: 14px;
        transition: all 0.3s ease;
    }
    
    .primary-btn {
        background-color: $active;
        border-color: $active;
        
        &:hover {
            background-color: darken($active, 5%);
            border-color: darken($active, 5%);
            color: $commonColor;
        }
    }
}

// Dark mode styles
.dark {
    .modal-dialog-breakup {
        background-color: $cardBackgroundDark;
    }
    
    .modal-header {
        border-bottom-color: $text-darkColor;
        
        .premium-revised-title {
            color: $success !important;
        }
    }
    
    .differernce_table {
        box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
        
        tbody {
            tr {
                &:nth-child(even) {
                    // background-color: rgba($text-darkColor, 0.1);
                }
                
                &:hover {
                    background-color: rgba($text-darkColor, 0.2);
                }
            }
            
            tr.highlight-row {
                background-color: rgba($main-bg, 0.2);
            }
            
            tr.section-header {
                background-color: $cardBackgroundDark;
                
                th {
                    color: $heading-darkColor;
                }
            }
            
            th {
                color: $text-darkColorTransparent;
            }
            
            td {
                color: $text-darkColor;
                
                .premium-amount {
                    color: $text-darkColorTransparent;
                }
                
                .included-text {
                    color: $verify-color;
                }
            }
        }
    }
    
    .inspection-info {
        background-color: $cardBackgroundDark;
        
        .inspection-text {
            span{
                color: #EC920F !important;
            }
        }
    }
}
</style>
